import { useEffect } from "react";

const BASE_URL = "https://stansbury.ai";
const OG_IMAGE = `${BASE_URL}/og-image.png`;
const SITE_NAME = "Stansbury AI";

export function usePageSEO({ title, description, path, ogTitle, ogDescription, noIndex = false }) {
  useEffect(() => {
    // Title
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Turn AI Into Your #1 Revenue Engine`;
    document.title = fullTitle;

    // Meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) metaDesc.setAttribute("content", description);

    // Robots — noindex for internal pages
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", noIndex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large");

    // Canonical
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && path) canonical.setAttribute("href", `${BASE_URL}${path}`);

    // OG tags
    const setMeta = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`) || document.querySelector(`meta[name="${prop}"]`);
      if (el && content) el.setAttribute("content", content);
    };
    setMeta("og:title", ogTitle || fullTitle);
    setMeta("og:description", ogDescription || description);
    setMeta("og:url", path ? `${BASE_URL}${path}` : BASE_URL);
    setMeta("twitter:title", ogTitle || fullTitle);
    setMeta("twitter:description", ogDescription || description);

    // Cleanup: restore defaults on unmount
    return () => {
      document.title = `${SITE_NAME} — Turn AI Into Your #1 Revenue Engine`;
      if (robots) robots.setAttribute("content", "index, follow, max-snippet:-1, max-image-preview:large");
    };
  }, [title, description, path, ogTitle, ogDescription, noIndex]);
}
